exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Jzw-vaEJwTi-bLAbmQ9-w .ms-Dialog-actionsRight{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}html[dir=ltr] ._3Jzw-vaEJwTi-bLAbmQ9-w .ms-Dialog-actionsRight{left:0}html[dir=rtl] ._3Jzw-vaEJwTi-bLAbmQ9-w .ms-Dialog-actionsRight{right:0}", ""]);
// Exports
exports.locals = {
	"joinMeetingDialogConfirmation": "_3Jzw-vaEJwTi-bLAbmQ9-w"
};